import { render, staticRenderFns } from "./DfDatePickerField.vue?vue&type=template&id=64c23c82&scoped=true&"
import script from "./DfDatePickerField.vue?vue&type=script&lang=js&"
export * from "./DfDatePickerField.vue?vue&type=script&lang=js&"
import style0 from "./DfDatePickerField.vue?vue&type=style&index=0&id=64c23c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c23c82",
  null
  
)

export default component.exports